export default [
    {path: '/users/:id/edit', screen: 'user/EditUser', secured: true, role: ['admin']},
    {path: '/users/:id', screen: 'user/DisplayUser', secured: true, role: ['admin']},
    {path: '/users', screen: 'user/ListUsers', secured: true, role: ['admin']},
    {path: '/user/new', screen: 'user/CreateUser', secured: true, role: ['admin']},
    {path: '/user', screen: 'user/Profile', secured: true},
]